module.exports = __webpack_public_path__ + "img/japanese-highball.dd8bd3b2.jpg";